module.exports = __webpack_public_path__ + "static/media/shape3.pngfeat0.33286288.png";